module.exports = __webpack_public_path__ + "img/light_3.71621743.png";